import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {
  Form,
  Input,
  Button,
  Col,
  Row,
  FormGroup,
  Label,
  FormFeedback,
} from 'reactstrap'
import {Mutation} from 'react-apollo'
import {SAVE_PROJECT} from './mutations'
import {UploadFiles, acceptedFiles, acceptedFilesIcons, updateAttachemntsInStore} from '../../utils/uploadFiles'
import _ from 'lodash'
import CreatableSelect from '../Wps/CreatableSelect'
import DropzoneComponent from 'react-dropzone-component'
import {FilesList} from '../Support/index'
import {onDestroySelect, destroyAttachments} from '../../utils/forms/removeFiles'

import {getUserPermissions} from '../../utils/userPermissions'

const formAttrNames = ['name', 'number', 'conditions_of_acceptance', 'planned_start_date', 'planned_end_date']

function GetFormValues(formElements) {
  formAttrNames.forEach(attr_name => {
    const formEl = formElements[attr_name]
    this[attr_name] = formEl.value
  })
}

const propTypes = {
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
  parentId: PropTypes.number.isRequired,
  element: PropTypes.object,
  companiesData: PropTypes.array.isRequired,
  inModal: PropTypes.bool
}

const defaultProps = {
  element: {},
  inModal: false
}

class ElementForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      project_companies: typeof props.element.project_companies === 'string' ? JSON.parse(props.element.project_companies) : (props.element.project_companies || []),
      files: [],
      filesSelectedToRemove: []
    }

    this.djsConfig = {
      addRemoveLinks: true,
      autoProcessQueue: false,
      acceptedFiles: acceptedFiles,
    }
    this.componentConfig = {
      iconFiletypes: acceptedFilesIcons,
      showFiletypeIcon: true,
      postUrl: 'no-url',
    }
    this.dropzone = null

    this.onDestroySelect = onDestroySelect.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.element.project_companies !== this.props.element.project_companies) {
      const raw = this.props.element.project_companies
      this.setState({
        project_companies: typeof raw === 'string' ? JSON.parse(raw) : (raw || [])
      })
    }
  }

  handleSubmit(e, client, submitFunction) {
    e.preventDefault()

    let variables = _.assign({}, new GetFormValues(e.target.elements))
    variables.parent_id = this.props.parentId
    this.props.element.id && (variables.id = this.props.element.id)
    variables.project_companies = JSON.stringify(this.state.project_companies)

    submitFunction({
      variables: {attributes: variables},
      refetchQueries: ({data: {createOrUpdateProjects}}) => {
        const queries = !this.props.element.id && !createOrUpdateProjects.errors ? ['GetElements'] : []
        return [...queries, 'GetElement']
      },
    }).then(
      ({data: {createOrUpdateProjects}}) => {
        if (createOrUpdateProjects.errors) return
        const element_id = createOrUpdateProjects.project.id
        // REMOVE FILES
        destroyAttachments(client, this.state.filesSelectedToRemove, element_id, 'WlWelds::Project', 'Project')

        // ADD FILE
        if (this.state.files.length > 0) {
          UploadFiles(element_id, 'WlWelds::Project', this.state.files, {}).then((data) => {
            updateAttachemntsInStore(client, element_id, 'Project', {newAttachments: data})
          })
        }

        this.setState({files: [], filesSelectedToRemove: []})
        this.dropzone.removeAllFiles(true)
        this.props.onSaved && this.props.onSaved()
        this.props.onSubmit && this.props.onSubmit()
      }
    )
  }

  handleFileAdded(file) {
    this.setState({files: [...this.state.files, file]})
  }

  handleFileRemoved(file) {
    let newFilesList = this.state.files.filter(function (item) {
      return (item !== file)
    })

    this.setState({files: newFilesList})
  }

  render() {
    const eventHandlers = {
      init: dz => this.dropzone = dz,
      addedfile: this.handleFileAdded.bind(this),
      removedfile: this.handleFileRemoved.bind(this),
    }

    const colSize = this.props.inModal ? 12 : 4
    return (
      <Mutation mutation={SAVE_PROJECT}>
        {(createOrUpdateProjects, {data, loading, client}) => {
          const errors = (data && !loading && JSON.parse(data.createOrUpdateProjects.errors)) || {}
          const {element} = this.props
          return (
            <Form className='FormClassLabel' onSubmit={e => this.handleSubmit(e, client, createOrUpdateProjects)}>
              <Row>
                <Col md={colSize}>
                  <FormGroup>
                    <Label for='element-name-input'>Name</Label>
                    <Input
                      id='material-trade-name-input'
                      invalid={!!errors.name}
                      name="name"
                      type="text"
                      defaultValue={element.name}
                      required
                    />
                    <FormFeedback>{errors.name}</FormFeedback>
                  </FormGroup>
                </Col>
                <Col md={colSize}>
                  <FormGroup>
                    <Label for='element-number-input'>Number</Label>
                    <Input
                      id='element-number-input'
                      invalid={!!errors.number}
                      name="number"
                      type="text"
                      defaultValue={element.number}
                    />
                    <FormFeedback>{errors.number}</FormFeedback>
                  </FormGroup>
                </Col>
                <Col md={colSize}>
                  <FormGroup>
                    <Label for='element-conditions-of-acceptance-input'>Conditions of acceptance</Label>
                    <Input
                      id='element-conditions-of-acceptance-input'
                      invalid={!!errors.conditions_of_acceptance}
                      name="conditions_of_acceptance"
                      type="text"
                      defaultValue={element.conditions_of_acceptance}
                    />
                    <FormFeedback>{errors.conditions_of_acceptance}</FormFeedback>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={colSize}>
                  <FormGroup>
                    <Label for='element-planned-start-date-input'>Planned start date</Label>
                    <Input
                      id='element-planned-start-date-input'
                      invalid={!!errors.planned_start_date}
                      name="planned_start_date"
                      type="date"
                      defaultValue={(element.planned_start_date || '').split('-').reverse().join('-')}
                    />
                    <FormFeedback>{errors.planned_start_date}</FormFeedback>
                  </FormGroup>
                </Col>
                <Col md={colSize}>
                  <FormGroup>
                    <Label for='element-planned-end-date-input'>Planned end date</Label>
                    <Input
                      id='element-planned-end-date-input'
                      invalid={!!errors.planned_end_date}
                      name="planned_end_date"
                      type="date"
                      defaultValue={(element.planned_end_date || '').split('-').reverse().join('-')}
                    />
                    <FormFeedback>{errors.planned_end_date}</FormFeedback>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={colSize}>
                  <FormGroup>
                    <label>Companies</label>
                    {(this.props.companiesData || []).map(company => {
                      const entry = this.state.project_companies.find(pc => String(pc.id) === String(company.id))
                      const checked = !!entry
                      const isExecutor = entry ? !!entry.executor : false
                      return (
                        <div key={company.id} style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '4px' }}>
                          <Input
                            type="checkbox"
                            checked={checked}
                            style={{ position: 'static', margin: 0 }}
                            onChange={e => {
                              if (e.target.checked) {
                                this.setState(s => ({ project_companies: [...s.project_companies, { id: company.id, executor: false }] }))
                              } else {
                                this.setState(s => ({ project_companies: s.project_companies.filter(pc => String(pc.id) !== String(company.id)) }))
                              }
                            }}
                          />
                          <span style={{ minWidth: '140px' }}>{company.name}</span>
                          {checked && (
                            <label style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '4px', color: '#555' }}>
                              <Input
                                type="checkbox"
                                checked={isExecutor}
                                style={{ position: 'static', margin: 0 }}
                                onChange={e => {
                                  const checked = e.target.checked
                                  this.setState(s => ({
                                    project_companies: s.project_companies.map(pc =>
                                      String(pc.id) === String(company.id) ? { ...pc, executor: checked } : pc
                                    )
                                  }))
                                }}
                              />
                              executor
                            </label>
                          )}
                        </div>
                      )
                    })}
                  </FormGroup>
                </Col>
              </Row>
              <FormGroup>
                <DropzoneComponent config={this.componentConfig} eventHandlers={eventHandlers}
                  djsConfig={this.djsConfig}/>
              </FormGroup>
              <FilesList files={element.attachments} onDestroySelect={this.onDestroySelect}/>

              <hr/>
              {this.props.onClose && <Button id="cancel-base-material-form-btn" className="float-right" color="danger"
                onClick={(e) => {
                  e.preventDefault()
                  this.props.onClose()
                }
                }>Cancel</Button>}
              <Button id="save-base-material-form-btn" className="float-right" color="primary"
                type="submit">Save</Button>
            </Form>
          )
        }}
      </Mutation>
    )
  }
}

ElementForm.propTypes = propTypes
ElementForm.defaultProps = defaultProps

export default ElementForm



// WEBPACK FOOTER //
// ./src/components/Projects/ElementForm.js